import { Component, OnInit, Input, ViewEncapsulation } from '@angular/core';
import { Attachment } from '../../models/subject';
import { FileDownloadService } from '../../../../../services/file-download-service/file-download.service';
import { StudentSubjectsService } from '../../services/student-subject/student-subjects.service';
import { switchMap } from 'rxjs/operators';


@Component({
  selector: 'app-lesson-attachment',
  templateUrl: './lesson-attachment.component.html',
  styleUrls: ['./lesson-attachment.component.scss'],
  encapsulation:ViewEncapsulation.None
})
export class LessonAttachmentComponent implements OnInit {

  constructor(private fileDownloadService: FileDownloadService
    , private studentSubjectsService: StudentSubjectsService) { }

  @Input('data') attachments: Array<Attachment> = [];

  ngOnInit() {

  }

  attachmentClicked(attachment: Attachment) {
    this.studentSubjectsService.getPresignedUrlOfLessonDoc(attachment.subject_note_id, attachment.subject_note_attachment_id)
      .pipe(
        switchMap(res => {
          return this.fileDownloadService.downloadAndOpen(res.url, res.file_name, res.content_type, true);
        })
      ).subscribe()
  }
}
